<template>
  <div class="data-wrapper-core">
    <h3>Leads</h3>
    <div class="content-data-table-wrapper">
      <v-text-field
        class="content-data-search"
        flat
        v-model="search"
        label="Suche"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        density="compact"
        hide-details
        single-line
        rounded="lg"
      ></v-text-field>
      <v-data-table
        class="content-data-table"
        density="compact"
        :headers="headers"
        :items="leads"
        :search="search"
      >
        <template v-slot:item="{ item }">
          <tr class="v-table-row" @click="openLeadDialog(item)">
            <td>{{ item.name }}</td>
            <td>{{ item._id }}</td>
            <td>{{ formatDate(item.createdAt) }}</td>
          </tr>
        </template>
      </v-data-table>
      <LeadDialog
        v-if="selectedLead._id"
        :leadId="selectedLead._id"
      ></LeadDialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import LeadDialog from "../leadDialog/LeadDialog.vue";

export default {
  components: {
    LeadDialog,
  },
  props: {
    tables: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      search: "",
      headers: [
        { key: "name", title: "Name", sortable: true },
        { key: "__id", title: "Lead ID", sortable: true },
        { key: "createdAt", title: "Erstellungsdatum", sortable: true },
      ],
      selectedLead: {},
    };
  },
  computed: {
    ...mapState("table", ["leads"]),
  },
  methods: {
    ...mapMutations("table", ["resetTable"]),
    openLeadDialog(item) {
      this.$store.commit("lead/setLeadDialog", true);
      this.$store.commit("table/setTableDialog", false);
      this.$store.commit("table/resetTable");
      this.$router.push({ name: "lead", params: { leadId: item._id } });
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-data-search {
  margin: 8px 0;
  border-radius: 12px;
}
.v-table {
  background-color: #f9fafb;
}

.v-table-row {
  cursor: pointer;
}

.content-dialog-customer {
  margin: 8px 0;
}
</style>
